import formsSelect from "./forms/_select.js";
import otherHeadAlert from "./others/_head-alert.js";
import buttonsFavorite from "./buttons/_favorite.js";
import basicsBadge from './basics/_badge.js';
import othersSearchMenu from "./others/_search-menu.js";
import othersSearchList from "./others/_search-list.js";
import othersHamburger from "./others/_hamburger.js";
import othersFoot from "./others/_foot.js";
import cardsEstate from "./cards/_estate.js";
import login from "./buttons/_login.js";

const components = () => {
    formsSelect();
    otherHeadAlert();
    buttonsFavorite();
    cardsEstate();
    basicsBadge();
    othersSearchMenu();
    othersSearchList();
    othersHamburger();
    othersFoot();
    login()
}

export default components;
